import { OK } from 'http-status-codes'

import getAxiosInstance from '../../helpers/get_axios_instance'

export const finalizarLlenado = async (silo) => {
  const axios = getAxiosInstance()
  const promise = axios.post(
    `/silo_lleno`,
    `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo finalizar el llenado.')
    return data
  })
}

export const vaciar = async (silo) => {
  const axios = getAxiosInstance()
  const promise = axios.post(
    `/silo_vacio`,
    `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo finalizar el llenado.')
    return data
  })
}

export const anularInicioLlenado = async (silo) => {
  const axios = getAxiosInstance()
  const promise = axios.delete(
    `/silo_en_carga?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
    return data
  })
}

export const anularFinLlenado = async (silo) => {
  const axios = getAxiosInstance()
  const promise = axios.delete(
    `/silo_lleno?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
    return data
  })
}

export const anularVaciado = async (silo) => {
  const axios = getAxiosInstance()
  const promise = axios.delete(
    `/silo_vacio?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
    return data
  })
}

export const cubicar = async (silo, metrosDeVacio, ph) => {
  const axios = getAxiosInstance()
  const promise = axios.post(
    `/operacion_cubicaje_silo`,
    `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","metros_de_vacio":"${metrosDeVacio}"${ph ? `,"ph":"${ph}"` : ''}}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo cubicar.')
    return data
  })
}

export const fumigar = async (silo, producto, observaciones) => {
  const axios = getAxiosInstance()
  const promise = axios.post(
    `/operacion_fumigado_silo`,
    `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad || 'UNDEF'}"${
      producto ? `,"producto":"${producto}"` : ''
    }${observaciones ? `,"observaciones":"${observaciones}"` : ''}}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo fumigar.')
    return data
  })
}
export const modificarCubicaje = async (silo, metrosDeVacio, ph) => {
  const axios = getAxiosInstance()
  const valores = {}
  const clave = {
    silo: silo.nombreCorto,
    cereal: silo.cereal,
    cereal_variedad: silo.cerealVariedad,
    fecha_de_referencia: silo.fechaUltimoCubicaje
  }
  if (metrosDeVacio) {
    valores.metros_de_vacio = metrosDeVacio
  }
  if (ph) {
    valores.ph = ph
  }
  const promise = axios.put(`/operacion_cubicaje_silo`, { valores, clave })
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo modificar el cubicaje.')
    return data
  })
}

export const anularCubicaje = async ({ nombreCorto, cereal, cerealVariedad, fechaUltimoCubicaje }) => {
  const axios = getAxiosInstance()
  const promise = axios.delete(
    `/operacion_cubicaje_silo?r={"clave":{"silo":"${nombreCorto}","cereal":"${cereal}","cereal_variedad":"${
      cerealVariedad || 'UNDEF'
    }","fecha_de_referencia":"${fechaUltimoCubicaje}"}}`
  )
  return promise.then((result) => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo anular el cubicaje.')
    return data
  })
}

export const anularFumigado = async (silo) => {
  const axios = getAxiosInstance()
  const { status, data } = await axios.delete(
    `/operacion_fumigado_silo?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
      silo.cerealVariedad || 'UNDEF'
    }","fecha_de_referencia":"${silo.fechaUltimoFumigado}"}}`
  )
  if (status !== OK) {
    throw new Error('No se pudo anular el fumigado.')
  }
  return data
}

export const modificarFumigado = async (silo, producto, observaciones) => {
  const axios = getAxiosInstance()
  const valores = {}
  const clave = {
    silo: silo.nombreCorto,
    cereal: silo.cereal,
    cereal_variedad: silo.cerealVariedad,
    fecha_de_referencia: silo.fechaUltimoFumigado
  }
  if (producto) {
    valores.producto = producto
  }
  if (observaciones) {
    valores.observaciones = observaciones
  }
  const { status, data } = await axios.put(`/operacion_fumigado_silo`, { valores, clave })
  if (status !== OK) {
    throw new Error('No se pudo modificar el fumigado.')
  }
  return data
}

export const iniciarLlenado = async (silo, cereal, variedad, etiqueta, color) => {
  const { status, data } = await getAxiosInstance().post(
    `/silo_en_carga`,
    `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${cereal}","cereal_variedad":"${variedad || 'UNDEF'}"${
      etiqueta ? `,"etiqueta":"${etiqueta}"` : ''
    }${color ? `,"color":"${color}"` : ''}}}`
  )
  if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
  return data
}

export const modificarInicioDeLlenado = async (silo, cereal, variedad, etiqueta, color) => {
  const { status, data } = await getAxiosInstance().put(
    `/silo_en_carga`,
    { clave: {
      silo: silo.nombreCorto,
      cereal: silo.cereal,
      cereal_variedad: silo.cerealVariedad,
      fecha_inicio_llenado: silo.fechaInicioLlenado
    },
    valores: {
      cereal,
      variedad,
      etiqueta,
      color
    } }
  )
  if (status !== OK) throw new Error('No se pudo modificar el inicio de llenado.')
  return data
}

class Movimiento {
  static async getColorDeEtiqueta (etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/etiqueta_color?r={"clave":{"etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el color.')
      const color = data.filas[0].color.trim().toLowerCase()
      return color.startsWith('#') ? color : '#' + color
    })
  }

  static async getMovimiento (cereal = null, variedad = null) {
    const axios = getAxiosInstance()
    let promise = axios.get(`/consulta_estado_silos?={"orden":["sector"]}`)
    if (cereal && variedad) {
      promise = axios.get(`/consulta_estado_silos_filtrada?r=` +
        `{"clave":{"cereal":"${cereal}","cereal_variedad":"${variedad}"}, "orden":["sector"]}`)
    }
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  }

  static async getTotalesPorLineaD3View () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_sector_linea`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  }

  static async getDataForCerealPorLineaD3View () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_silos_sector_linea_completo`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  }

  static async getConsultaTotalSilosLinea () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_silos_linea`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data.filas
    })
  }

  static async getEstadoElevador () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_estado_elevador`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el estado del elevador.')
      return data
    })
  }

  static async getFumigado (silo) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `/consulta_operacion_fumigado_silo?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_de_referencia":"${silo.fechaUltimoFumigado}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el fumigado.')
      const fumigado = {
        observaciones: data.filas[0].observaciones ? data.filas[0].observaciones.trim() : '',
        producto: data.filas[0].producto ? data.filas[0].producto.trim() : ''
      }
      return fumigado
    })
  }

  static async getCubicaje (silo) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `/consulta_operacion_cubicaje_silo?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_de_referencia":"${silo.fechaUltimoCubicaje}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el cubicaje.')
      const cubicaje = {
        metrosDeVacio: data.filas[0].metrosDeVacio ? data.filas[0].metrosDeVacio : '',
        ph: data.filas[0].ph ? data.filas[0].ph : ''
      }
      return cubicaje
    })
  }

  static async inicioLlenado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.post(
      `/silo_en_carga`,
      `{"valores": {"silo":"${silo.silo.trim()}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad || 'UNDEF'}"${
        silo.etiqueta ? `,"etiqueta":"${silo.etiqueta}"` : ''
      }${silo.color ? `,"color":"${silo.color}"` : ''}}}`
    )
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
      return data
    })
  }

  static async modificarLlenado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    // SET etiqueta = new.etiqueta, color = new.color
    // WHERE ((movimiento_silo.silo = new.silo) AND (movimiento_silo.cereal = new.cereal) AND (movimiento_silo.cereal_variedad = new.cereal_variedad) AND (movimiento_silo.fecha_inicio_llenado = new.fecha_inicio_llenado))
    const valores = {}
    const clave = {
      silo: silo.silo,
      cereal: silo.cereal,
      cereal_variedad: silo.cerealVariedad,
      fecha_inicio_llenado: silo.fechaInicioLlenado
    }
    if (silo.etiqueta) {
      valores.etiqueta = silo.etiqueta
    }
    if (silo.color) {
      valores.color = silo.color
    }
    const promise = axios.put(`/silo_en_carga`, { clave, valores })
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo modificar el llenado.')
      return data
    })
  }

  static async anularInicioLlenado (silo) {
    const axios = getAxiosInstance()
    const promise = axios.delete(
      `/silo_en_carga?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo iniciar el llenado.')
      return data
    })
  }

  static async finalizarLlenado (silo) {
    const axios = getAxiosInstance()
    const promise = axios.post(
      `/silo_lleno`,
      `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo finalizar el llenado.')
      return data
    })
  }

  static async anularFinalizarLlenado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.delete(
      `/silo_lleno?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
    )
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo anular el llenado.')
      return data
    })
  }

  static async vaciar (silo) {
    const axios = getAxiosInstance()
    const promise = axios.post(
      `/silo_vacio`,
      `{"valores": {"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo finalizar el llenado.')
      return data
    })
  }

  static async anularVaciado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.delete(
      `/silo_vacio?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_inicio_llenado":"${silo.fechaInicioLlenado}"}}`
    )
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo anular el vaciado.')
      return data
    })
  }

  static async fumigar (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.post(
      `/operacion_fumigado_silo`,
      `{"valores": {"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad || 'UNDEF'}"${
        silo.producto ? `,"producto":"${silo.producto}"` : ''
      }${silo.observaciones ? `,"observaciones":"${silo.observaciones}"` : ''}}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo fumigar.')
      return data
    })
  }

  static async anularFumigado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.delete(
      `/operacion_fumigado_silo?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_de_referencia":"${silo.fechaUltimoFumigado}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo anular el fumigado.')
      return data
    })
  }

  static async modificarFumigado (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    // SET etiqueta = new.etiqueta, color = new.color
    // WHERE ((movimiento_silo.silo = new.silo) AND (movimiento_silo.cereal = new.cereal) AND (movimiento_silo.cereal_variedad = new.cereal_variedad) AND (movimiento_silo.fecha_inicio_llenado = new.fecha_inicio_llenado))
    const valores = {}
    const clave = {
      silo: silo.silo,
      cereal: silo.cereal,
      cereal_variedad: silo.cerealVariedad,
      fecha_de_referencia: silo.fechaUltimoFumigado
    }
    if (silo.producto) {
      valores.producto = silo.producto
    }
    if (silo.observaciones) {
      valores.observaciones = silo.observaciones
    }
    const promise = axios.put(`/operacion_fumigado_silo`, { valores, clave })
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo modificar el fumigado.')
      return data
    })
  }

  static async cubicar (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.post(
      `/operacion_cubicaje_silo`,
      `{"valores": {"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","metros_de_vacio":"${silo.metros_de_vacio}"${silo.ph ? `,"ph":"${silo.ph}"` : ''}}}`
    )
    // return promise.then(lrsAdapter, lrsAdapter)
    // new.silo, new.cereal, new.cereal_variedad, new.metros_de_vacio, new.ph
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo fumigar.')
      return data
    })
  }

  static async modificarCubicaje (silo) {
    const axios = getAxiosInstance()
    const valores = {}
    const clave = {
      silo: silo.silo,
      cereal: silo.cereal,
      cereal_variedad: silo.cerealVariedad,
      fecha_de_referencia: silo.fechaUltimoCubicaje
    }
    if (silo.metrosDeVacio) {
      valores.metros_de_vacio = silo.metrosDeVacio
    }
    if (silo.ph) {
      valores.ph = silo.ph
    }
    const promise = axios.put(`/operacion_cubicaje_silo`, { valores, clave })
    // return promise.then(lrsAdapter, lrsAdapter)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo modificar el cubicaje.')
      return data
    })
  }

  static async anularCubicaje (silo) {
    const axios = getAxiosInstance()
    // const promise = axios.put(`/silo_en_carga?r={"clave":{"silo":"${silo.silo}","cereal":"${silo.cereal}","cereal_variedad":"${silo.cerealVariedad||'UNDEF'}","etiqueta":"${silo.etiqueta}"}}`)
    const promise = axios.delete(
      `/operacion_cubicaje_silo?r={"clave":{"silo":"${silo.nombreCorto}","cereal":"${silo.cereal}","cereal_variedad":"${
        silo.cerealVariedad || 'UNDEF'
      }","fecha_de_referencia":"${silo.fechaUltimoCubicaje}"}}`
    )
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo anular el cubicaje.')
      return data
    })
  }

  static async getConsultaTotalEspacioSiloCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_espacio_por_cereal`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado desde consulta total espacio por cereal.')
      return data.filas
    })
  }

  static async getConsultaTotalEspacioElevador () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_espacio_elevador`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado desde consulta_total_espacio_elevador.')
      return data.filas
    })
  }
}

export default Movimiento
